import { FC } from 'react';
import Select from 'react-select';
import { Row, Col } from 'react-bootstrap';
import { useLabRequestsList, TYPE_OPTIONS } from './useLabRequestsList';
import { ManagementListSkeleton } from '../../Management/components/ManagementListSkeleton';
import { ReadOnlyLabRequestForm } from './ReadOnlyLabRequestForm';
import { Pagination } from '../../../common/components/Pagination';
import { dateHelper } from '../../../helpers/help_functions/date_helpers';
import PulseLoader from 'react-spinners/PulseLoader';
import {
  ListContainer,
  FilterRow,
  FilterLabel,
  FilterSelectWrapper,
  TableCard,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  EmptyTableRow,
  RightPanelCard,
  RightPanelEmpty,
  PrintButtonRow,
  PrintButton
} from './styles';

const ALL_OPTION = { value: 'all', label: 'Všechny žádanky' };
const SELECT_OPTIONS = [ALL_OPTION, ...TYPE_OPTIONS];

const selectStyles = {
  control: (base: any) => ({
    ...base,
    borderRadius: 0,
    minHeight: 42,
    boxShadow: 'none'
  })
};

export const LabRequestsList: FC = () => {
  const {
    selectedType, requests, loading, printing, selectedRequest,
    limit, offset, page, count,
    handleTypeChange, handleRowClick, handlePagination, handleLimitChange, handlePrint
  } = useLabRequestsList();

  const selectedOption =
    selectedType === 'all'
      ? ALL_OPTION
      : (TYPE_OPTIONS.find((o) => o.value === selectedType) ?? null);

  return (
    <ListContainer>
      <FilterRow>
        <FilterLabel>Typ žádanky:</FilterLabel>
        <FilterSelectWrapper>
          <Select
            options={SELECT_OPTIONS}
            isClearable
            placeholder="Vyberte typ..."
            styles={selectStyles}
            value={selectedOption}
            onChange={(opt) => handleTypeChange(opt ? (opt.value as any) : null)}
          />
        </FilterSelectWrapper>
      </FilterRow>

      <Row>
        <Col md={4}>
          <TableCard>
            <StyledTable>
              <StyledTableHead>
                <tr>
                  <th>Datum odeslání</th>
                  <th>Typ žádanky</th>
                  <th>Stav žádanky</th>
                </tr>
              </StyledTableHead>
              <StyledTableBody>
                {loading && <ManagementListSkeleton columns={3} rows={5} />}
                {!loading && !selectedType && (
                  <EmptyTableRow>
                    <td colSpan={3}>Vyberte typ žádanky pro zobrazení seznamu.</td>
                  </EmptyTableRow>
                )}
                {!loading && selectedType && requests.length === 0 && (
                  <EmptyTableRow>
                    <td colSpan={3}>Žádné odeslané žádanky tohoto typu.</td>
                  </EmptyTableRow>
                )}
                {!loading &&
                  requests.map((req) => (
                    <tr
                      key={`${req._complementType}-${req.id}`}
                      onClick={() => handleRowClick(req)}
                      className={
                        selectedRequest?.data?.id === req.id &&
                        selectedRequest?.type === req._complementType
                          ? 'active'
                          : ''
                      }
                    >
                      <td>{req.sent_at ? dateHelper.formatDateTimeCZ(req.sent_at) : '–'}</td>
                      <td>{TYPE_OPTIONS.find((o) => o.value === req._complementType)?.label ?? '–'}</td>
                      <td>Odesláno</td>
                    </tr>
                  ))}
              </StyledTableBody>
            </StyledTable>
          </TableCard>

          {selectedType && selectedType !== 'all' && (
            <Pagination
              count={count}
              offset={offset}
              page={page}
              limit={limit}
              onSubmit={handlePagination}
              onLimitChange={handleLimitChange}
            />
          )}
        </Col>

        <Col md={8}>
          {selectedRequest ? (
            <RightPanelCard>
              {!['genetics', 'nrl_other'].includes(selectedRequest.type) && (
                <PrintButtonRow>
                  <PrintButton type="button" onClick={handlePrint}>{!printing ? 'Tisk žádanky' : <PulseLoader className="pulse-loader" size={6} color="#3c1149"/>}</PrintButton>
                </PrintButtonRow>
              )}
              <ReadOnlyLabRequestForm
                key={`${selectedRequest.type}-${selectedRequest.data.id}`}
                type={selectedRequest.type}
                data={selectedRequest.data}
              />
            </RightPanelCard>
          ) : (
            <RightPanelEmpty>Vyberte žádanku ze seznamu pro zobrazení detailu.</RightPanelEmpty>
          )}
        </Col>
      </Row>
    </ListContainer>
  );
};

